export interface Chapter {
  num: number;
  title: string;
  pages: number;
  date: string;
}

export const overflowChapters: Chapter[] = [
  { num: 1, title: "初次见面", pages: 32, date: "2026-03-02" },
  { num: 2, title: "游泳部的邀请", pages: 34, date: "2026-03-09" },
  { num: 3, title: "第一堂训练课", pages: 30, date: "2026-03-16" },
  { num: 4, title: "池边的秘密", pages: 36, date: "2026-03-23" },
  { num: 5, title: "同款泳镜", pages: 32, date: "2026-03-30" },
  { num: 6, title: "换气练习", pages: 30, date: "2026-04-06" },
  { num: 7, title: "梅雨季", pages: 34, date: "2026-04-13" },
  { num: 8, title: "池底的光", pages: 36, date: "2026-04-20" },
  { num: 9, title: "放学后的练习", pages: 32, date: "2026-04-27" },
  { num: 10, title: "接力选拔", pages: 38, date: "2026-05-04" },
  { num: 11, title: "心跳加速", pages: 30, date: "2026-05-11" },
  { num: 12, title: "夜晚的泳池", pages: 34, date: "2026-05-18" },
  { num: 13, title: "小小的误会", pages: 32, date: "2026-05-25" },
  { num: 14, title: "一起晨练", pages: 30, date: "2026-06-01" },
  { num: 15, title: "游泳服", pages: 36, date: "2026-06-08" },
  { num: 16, title: "台风天", pages: 34, date: "2026-06-15" },
  { num: 17, title: "池边的脚印", pages: 32, date: "2026-06-22" },
  { num: 18, title: "训练赛", pages: 38, date: "2026-06-29" },
  { num: 19, title: "鼓起勇气", pages: 34, date: "2026-07-06" },
  { num: 20, title: "约定", pages: 32, date: "2026-07-13" },
  { num: 21, title: "假日训练营", pages: 40, date: "2026-07-20" },
  { num: 22, title: "深水区", pages: 34, date: "2026-07-27" },
  { num: 23, title: "回旋的水花", pages: 32, date: "2026-08-03" },
  { num: 24, title: "彼此的鼓励", pages: 34, date: "2026-08-10" },
  { num: 25, title: "告白前夕", pages: 36, date: "2026-08-15" },
];

export const chapterTitlesByManga: Record<string, { num: number; title: string; pages: number; date: string }[]> = {
  "moonlight-cafeteria": [
    { num: 1, title: "深夜的第一碗面", pages: 28, date: "2026-02-01" },
    { num: 2, title: "柠檬水的约定", pages: 30, date: "2026-02-08" },
    { num: 3, title: "食堂的老位置", pages: 28, date: "2026-02-15" },
    { num: 4, title: "暖黄灯光", pages: 32, date: "2026-02-22" },
    { num: 5, title: "说不出口的话", pages: 30, date: "2026-03-01" },
  ],
  "cat-diary": [
    { num: 1, title: "第一位顾客", pages: 26, date: "2026-01-05" },
    { num: 2, title: "窗台上的猫", pages: 28, date: "2026-01-12" },
    { num: 3, title: "今天的特调", pages: 30, date: "2026-01-19" },
    { num: 4, title: "午后的阳光", pages: 28, date: "2026-01-26" },
    { num: 5, title: "毛茸茸的一天", pages: 30, date: "2026-02-02" },
  ],
  "summer-echo": [
    { num: 1, title: "出发去海边", pages: 30, date: "2026-06-01" },
    { num: 2, title: "篝火前", pages: 32, date: "2026-06-08" },
    { num: 3, title: "海边的告白", pages: 34, date: "2026-06-15" },
    { num: 4, title: "烟花与约定", pages: 32, date: "2026-06-22" },
  ],
};